<template>
  <div id="app">
    <HomePage/>
    <Footer/>
  </div>
</template>

<script>
import HomePage from '@/components/HomePage.vue'
import Footer from "@/components/Footer";

export default {
  name: 'App',
  components: {
    HomePage,
    Footer
  }
}
</script>

<style>

</style>
